import React from 'react';
import { useDispatch } from 'react-redux';
import FailedLoginMessage from 'components/messages/FailedLoginMessage';
import { setMessage } from 'store/actions/system';
import SendCodeSuccess from 'components/messages/SendCodeSuccess';
import SendCodeFailure from 'components/messages/SendCodeFailure';
import GenericFailureMessage from 'components/messages/GenericFailureMessage';
import ValidateEmailSuccess from 'components/messages/ValidateEmailSuccess';
import PasswordResetSuccesMessage from 'components/messages/PasswordResetSuccesMessage';
import TooManyAttemptsMessage from 'components/messages/TooManyAttemptsMessage';
import NoNetworkMessage from 'components/messages/NoNetworkMessage';
import Message from 'components/Message';

export default () => {
  const dispatch = useDispatch();

  const handleDismiss = () => dispatch(setMessage(null));

  return {
    noNetworkMessage: () => {
      dispatch(setMessage(<NoNetworkMessage onDismiss={handleDismiss} />));
    },

    failedLoginMessage: (handleLoginWithOtherAccount, handleResetPassword) => {
      dispatch(
        setMessage(
          <FailedLoginMessage
            onNewLoginClick={handleLoginWithOtherAccount}
            onNewPasswordClick={handleResetPassword}
            onDismiss={handleDismiss}
          />,
        ),
      );
    },

    genericFailureMessage: (overrideText) => {
      dispatch(
        setMessage(
          <GenericFailureMessage
            text={overrideText}
            onDismiss={handleDismiss}
          />,
        ),
      );
    },

    genericInfoMessage: (text) => {
      dispatch(
        setMessage(
          <Message type="info" onDismiss={handleDismiss} message={text} />,
        ),
      );
    },

    genericWarningMessage: (text) => {
      dispatch(
        setMessage(
          <Message type="warning" onDismiss={handleDismiss} message={text} />,
        ),
      );
    },

    genericMessage: (text, type) => {
      dispatch(
        setMessage(
          <Message type={type} onDismiss={handleDismiss} message={text} />,
        ),
      );
    },

    sendCodeSuccess: () => dispatch(setMessage(<SendCodeSuccess onDismiss={handleDismiss} />)),

    validateEmailSuccess: () => dispatch(
      setMessage(<ValidateEmailSuccess onDismiss={handleDismiss} />),
    ),

    sendCodeFailure: (resendCode) => dispatch(
      setMessage(
        <SendCodeFailure
          onResendCodeClick={resendCode}
          onDismiss={handleDismiss}
        />,
      ),
    ),

    passwordResetSuccessMessage: () => dispatch(
      setMessage(<PasswordResetSuccesMessage onDismiss={handleDismiss} />),
    ),

    tooManyAttemptsMessage: () => dispatch(
      setMessage(
        <TooManyAttemptsMessage
          onDismiss={handleDismiss}
        />,
      ),
    ),

    clearMessage: () => dispatch(setMessage(null)),
  };
};
